module.exports = __webpack_public_path__ + "static/media/detailed.e3d9caa9.svg";